import { persistentReducedStream, streamReducer } from '@ardoq/rxbeach';
import { map } from 'rxjs';
import { filterRouteActive } from 'router/declarative/filterRouteActive';
import { AppLocation, location$ } from 'router/declarative/location$';
import { ViewpointsRoute } from './types';

export const VIEWPOINTS_ROUTE = '/viewpoints';

const defaultState: ViewpointsRoute = {
  viewpointId: null,
};

const toViewpointsRoute = (
  location: AppLocation<typeof VIEWPOINTS_ROUTE>
): ViewpointsRoute => {
  switch (location.route) {
    case '/viewpoints/legacy/:entityId':
      return { viewpointId: location.params.entityId };
    default:
      return { viewpointId: null };
  }
};

export const viewpointsRouteNavigation$ = location$.pipe(
  filterRouteActive(VIEWPOINTS_ROUTE),
  map(toViewpointsRoute)
);

const viewpointsNavigation$ = persistentReducedStream<ViewpointsRoute>(
  'viewpointsNavigation$',
  defaultState,
  [streamReducer(viewpointsRouteNavigation$, (_, route) => route)]
);

export { viewpointsNavigation$ };
